/**************************************************************************
Name:         jquery.offlinePaginatedTable.js
Description:  Static pagination controls
Date Created: 05/30/2014 by Kyle Brickman
Modified:
**************************************************************************/

( function( $ ){
	$.fn.offlinePaginatedTable = function( options )
	{
		var settings = $.extend({
			paginated      : true,
			sortable       : true,
			color          : 'blue',
			maxPageDisplay : 3,
			minPageDisplay : 1,
			perPage        : [1,25,50,100,250],
			pagePositions  : ['upper','lower'],
			responsive     : true,
			admin          : false,
			subadmin       : false,
			noclick        : false,
			noResultMsg	   : 'No results were found.',
			hasFilter 	   : false,
			sortableHtml   : false,
			classOpt 	   : '',
		}, options );

		return this.filter( 'table' ).each( function( index ){
			var drawResponsiveTable = function( )
			{
				if( !local.settings.responsive || local.table.width( ) <= local.table.parent( ).width( ))
				{
					local.table.parent( ).removeClass( 'scrollable' );
					local.responsive.addClass( 'hidden' );
					$( 'tr', local.table ).css( 'height', '' );
					return;
				}

				local.table.parent( ).addClass( 'scrollable' );

				local.responsive.empty( );

				$( 'tr', local.table ).clone( ).appendTo( local.responsive );

				$( 'th:not(:first-child), td:not(:first-child)', local.responsive ).remove( );

				local.responsive.css( 'width', $( 'th:first-child', local.table ).width( ) + 'px' );
				local.responsive.css( 'top',   local.table.position( ).top + 'px' );

				var oldCells = $( 'th:first-child, td:first-child', local.table      );
				var newCells = $( 'th:first-child, td:first-child', local.responsive );

				var ua = navigator.userAgent.toLowerCase( );
				var offset = 0;

				for( var i = 0; i < oldCells.length; i++ )
				{
					var oldCell = $( oldCells[i] );
					var newCell = $( newCells[i] );

					oldCell.parent( ).css( 'height', '' );

					newCell.parent( ).css( 'height', ( oldCell.parent( ).outerHeight( ) + 1 ) + 'px' );
					oldCell.parent( ).css( 'height', ( oldCell.parent( ).outerHeight( ) + 1 ) + 'px' );
				}

				local.responsive.attr( 'class', 'isResponsive ' + local.table.attr( 'class' ));
			};

			var drawPageLinksHighlightTimeout = 0;
			var drawPageLinksRemoveTimeout    = 0;
			var drawPageLinks = function( )
			{
				clearTimeout( drawPageLinksHighlightTimeout );
				clearTimeout( drawPageLinksRemoveTimeout    );

				$.each( local.pagination.positions, function( posIndex, posValue ){
					var currentPages = $( 'a:not([href="#first"],[href="#last"])', local.pagination[posValue].all ).removeAttr( 'data-remove' ).length;
					var appendTo     = $( 'div', local.pagination[posValue].all );

					for( var i = currentPages; i < local.view.pages; i++ )
					{
						var index = i + 1;
						var link = $( '<a />' );
						link.attr( 'title', 'Go to page ' + index );
						link.attr( 'href', '#' + index );
						link.text( index );

						link.addClass( 'inactive' );

						link.appendTo( appendTo );
					}

					for( var i = local.view.pages; i < currentPages; i++ )
					{
						var index = i + 1;
						$( 'a[href="#' + index + '"]', local.pagination[posValue].all ).attr( 'data-remove', true );
					}

					local.pagination[posValue].last.detach( ).appendTo( appendTo );
				});

				drawPageLinksHighlightTimeout = setTimeout( function( ){
					highlightPage( );
				}, 100 );

				drawPageLinksRemoveTimeout = setTimeout( function( ){
					$( 'a[data-remove]', local.wrapper ).remove( );
				}, 600 );
			}

			var setPage = function( )
			{
				if( $( this ).hasClass( 'active' ))
					return;

				var page = $( this ).attr( 'href' );

				if( '#first' == page ) page = $( 'a.active:not([href="#first"],[href="#last"])', $( this ).parent( ).parent( )).prev( ).attr( 'href' );
				if(  '#last' == page ) page = $( 'a.active:not([href="#first"],[href="#last"])', $( this ).parent( ).parent( )).next( ).attr( 'href' );

				local.view.page = parseInt( page.replace( '#', '' ), 10 );

				drawRecordSubset( );
				highlightPage(    );
			};

			var setPerPage = function( )
			{
				local.view.perPage = parseInt( $( this ).val( ));
				local.view.pages   = Math.ceil( local.view.records / local.view.perPage );

				if( local.view.page > local.view.pages )
					local.view.page = local.view.pages;

				drawRecordSubset( );
				drawPageLinks(    );
				highlightPerPage( );
			};

			var setSort = function( )
			{
				var link = $( this );

				if( link.hasClass( 'active' ))
					return;

				if( '#swap' == link.attr( 'href' ) && !$( 'a.active[href="#asc"]', link.parent( )).length )
					link = $( 'a[href="#asc"]', link.parent( ));
				else if( '#swap' == link.attr( 'href' ))
					link = $( 'a[href="#dsc"]', link.parent( ));

				local.view.sort = parseInt( link.attr( 'data-sort' ));

				var selectedSort    = $( 'a[data-sort="' + local.view.sort + '"]', local.header );
				var selectedSortDir = selectedSort.attr( 'href' ) == '#dsc';
				var selectedSortCol = selectedSort.parent( ).index( );

				var records = $( 'tr:not(.header)', local.table ).sort( function( left, right ){
					var  leftValue = parseInt( $(  left ).attr( 'data-sort-natural' ));
					var rightValue = parseInt( $( right ).attr( 'data-sort-natural' ));

					if( leftValue > rightValue ) return -1;
					if( leftValue < rightValue ) return  1;
					return 0;
				}).sort( function( left, right ){
					if( !selectedSortDir )
					{
						var temp = left;
						    left = right;
						   right = temp;
					}

					var  leftValue = $( $( 'td',  left ).get( selectedSortCol )).text( );
					var rightValue = $( $( 'td', right ).get( selectedSortCol )).text( );

					if(( parseFloat(  leftValue ) ==  leftValue && parseFloat( rightValue ) == rightValue ) ||
					   ( parseFloat(  leftValue ) ==  leftValue && !rightValue.length ) ||
					   ( parseFloat( rightValue ) == rightValue &&  !leftValue.length ))
					{
						if(  !leftValue.length )  leftValue = 9007199254740992 * -1;
						if( !rightValue.length ) rightValue = 9007199254740992 * -1;

						 leftValue = parseFloat(  leftValue );
						rightValue = parseFloat( rightValue );
					}
					else
					{
						 leftValue =  leftValue.toLowerCase( );
						rightValue = rightValue.toLowerCase( );
					}

					if( leftValue > rightValue ) return -1;
					if( leftValue < rightValue ) return  1;

					 leftValue = parseInt( $(  left ).attr( 'data-sort-natural' ));
					rightValue = parseInt( $( right ).attr( 'data-sort-natural' ));

					if( leftValue > rightValue ) return -1;
					if( leftValue < rightValue ) return  1;

					return 0;
				});

				records.detach( ).each( function( ){
					$( this ).appendTo( local.table );
				});

				drawRecordSubset( );
				highlightSort(    );
			};

			var highlightPage = function( page )
			{
				$.each( local.pagination.positions, function( posIndex, posValue ){
					// Determination of link state
					var firstToShow = local.view.page - local.settings['none' != local.pagination[posValue].select.css( 'display' ) ? 'maxPageDisplay' : 'minPageDisplay'];
					var  lastToShow = local.view.page + local.settings['none' != local.pagination[posValue].select.css( 'display' ) ? 'maxPageDisplay' : 'minPageDisplay'];

					// Set active classes
					$( 'a', local.pagination[posValue].all ).removeAttr( 'class' ).addClass( 'inactive' );
					local.pagination[posValue].first.removeClass( 'inactive' );
					local.pagination[posValue].last.removeClass(  'inactive' );

					$( 'a[href="#' + local.view.page + '"]', local.pagination[posValue].all ).addClass( 'active' )

					var allPages = $( 'a:not([href="#first"],[href="#last"])', local.pagination[posValue].all );

					allPages.each( function( index ){
						if( index + 1 >= firstToShow && index + 1 <= lastToShow && undefined == $( this ).attr( 'data-remove' ))
							$( this ).removeClass( 'inactive' );
					});

					allPages = $( 'a:not([href="#first"],[href="#last"])', local.pagination[posValue].all );

					if( allPages.first( ).hasClass( 'inactive' ) && undefined == allPages.first( ).attr( 'data-remove' )) allPages.first( ).removeClass( 'inactive' ).addClass( 'ellipse-right' );
					if( allPages.last(  ).hasClass( 'inactive' ) && undefined == allPages.last(  ).attr( 'data-remove' )) allPages.last(  ).removeClass( 'inactive' ).addClass( 'ellipse-left'  );

					if( allPages.first( ).hasClass( 'active' )) local.pagination[posValue].first.addClass( 'active' );
					if( allPages.last(  ).hasClass( 'active' )) local.pagination[posValue].last.addClass(  'active' );
				});
			};

			var highlightPerPage = function( )
			{
				$.each( local.pagination.positions, function( posIndex, posValue ){
					if( local.settings.admin )
						local.pagination[posValue].label.text( local.view.perPage );

					local.pagination[posValue].select.val( local.view.perPage );
				});
			};

			var highlightSort = function( )
			{
				$( 'a.active', local.header ).removeClass( 'active' );
				$( 'a[data-sort="' + local.view.sort + '"]', local.header ).addClass( 'active' );
			};

			var drawRecordSubset = function( )
			{
				var startingRecord = local.view.perPage * ( local.view.page - 1 )
				var   endingRecord = startingRecord + local.view.perPage;

				$( 'tr:not(.header)', local.table ).addClass( 'hidden' ).each( function( index ){
					if( index >= startingRecord && index < endingRecord || !local.settings.paginated )
						$( this ).removeClass( 'hidden' )
				});

				drawResponsiveTable( );
			};

			var eventSink = function( evt )
			{
				evt.preventDefault( );

				return;
			};

			// Establish root container
			var local = {};

			// Establish local settings
			local.settings = settings;

			// Support for admin override setting
			if( local.settings.admin )
			{
				local.settings.color         = 'blue';
				local.settings.perPage       = [1,25,50,100,250];
				local.settings.pagePositions = ['upper'];
				local.settings.responsive    = true;
			}

			// Establish view defaults
			local.view         = {};
			local.view.page    = 1;
			local.view.perPage = 25;
			local.view.sort    = 1;
			local.view.records = $( 'tr', this ).length - 1;
			local.view.pages   = Math.ceil( local.view.records / local.view.perPage );

			// Retrieve and create DOM housekeeping elements
			local.container   = $( this ).parent( );
			local.placeholder = $( '<span />' );
			local.wrapper     = $( '<div  />' );

			// Retrieve and create DOM table elements
			local.table           = $( this );
			local.responsive      = $( '<table />' );
			local.header          = $( 'tr', local.table ).first( );
			local.sortableColumns = [];

			// Insert temporary placeholder
			local.placeholder.insertBefore( local.table );
			local.table.detach( );

			// Set attributes
			local.table.removeAttr( 'class style' );

			// Set classes
			local.wrapper.addClass(      'paginatedTable' );
			local.table.addClass(    local.settings.color );
			local.table.addClass( local.settings.classOpt );
			local.header.addClass(               'header' );

			if( local.settings.admin    ) local.wrapper.addClass(   'admin' );
			if( local.settings.subadmin ) local.table.addClass(  'subadmin' );
			if( local.settings.noclick  ) local.wrapper.addClass( 'noclick' );

			// Multiline support
			if( local.settings.admin )
				$( 'th br, td br', local.header ).each( function( ){
					$( this ).parent( ).addClass( 'multiline' );
				});

			// Add sortable chevrons
			if( local.settings.sortable && local.view.records )
			{
				$( 'th[data-sort], td[data-sort]', local.header ).each( function( ){
					var cell  = $( this );
					var title = cell.text( );
					var swap  = $( '<a />' );
					var asc   = $( '<a />' );
					var dsc   = $( '<a />' );

					if (local.settings.sortableHtml) { title = cell.html(); }

					swap.attr( 'href', '#swap' );
					 asc.attr( 'href',  '#asc' );
					 dsc.attr( 'href',  '#dsc' );

					asc.attr( 'data-sort', cell.attr( 'data-sort' ).split( ',' )[0] );
					dsc.attr( 'data-sort', cell.attr( 'data-sort' ).split( ',' )[1] );

					swap.attr( 'title', 'Sort by \'' + title + '\'' );
					 asc.attr( 'title', 'Sort by \'' + title + '\', ascending'  );
					 dsc.attr( 'title', 'Sort by \'' + title + '\', descending' );

					asc.text( '\u25B2' );
					dsc.text( '\u25BC' );

					swap.text( title );
					if (local.settings.sortableHtml) { swap.html( title ); }

					cell.empty( );

					asc.attr('tabindex','-1');
					dsc.attr('tabindex','-1');

					asc.appendTo(  cell );
					dsc.appendTo(  cell );
					swap.appendTo( cell );

					local.sortableColumns.push( cell );
				});

				$( 'tr:not(.header)', local.table ).each( function( index ){
					$( this ).attr( 'data-sort-natural', index );
				})
			}
			else if( local.settings.sortable )
			{
				$( 'th[data-sort], td[data-sort]', local.header ).css( 'padding-left', '25px' );
			}

			// Sink events
			local.header.on( 'click', 'th[data-sort] a, td[data-sort] a', eventSink );

			// Bind events
			local.header.on( 'click', 'th[data-sort] a, td[data-sort] a', setSort );

			// Set no results message
			if( local.settings.hasFilter )
				local.settings.noResultMsg = 'To <b>search</b> please select from the filters above.';


			// Set blank row
			if( !local.view.records && local.settings.noResultMsg.length )
				$( '<tr><td colspan = "' + $( 'th, td', local.header ).length + '">' + local.settings.noResultMsg + '</td></tr>' ).appendTo( local.table )

			$( window ).on( 'resize orientationchange', drawResponsiveTable );

			// Pagination support
			local.pagination              = {};
			local.pagination.values       = local.settings.perPage;
			local.pagination.positions    = local.settings.pagePositions;

			if( !local.settings.paginated )
				local.pagination.positions = [];

			$.each( local.pagination.positions, function( posIndex, posValue ){
				// Retrieve and create DOM pagination elements
				local.pagination[posValue]               = {};
				local.pagination[posValue].all           = $( '<div    />' );
				local.pagination[posValue].perPage       = $( '<span   />' );
				local.pagination[posValue].label         = $( '<label  />' );
				local.pagination[posValue].select        = $( '<select />' );
				local.pagination[posValue].first         = $( '<a      />' );
				local.pagination[posValue].last          = $( '<a      />' );

				for( var i = 0; i < local.pagination.values.length; i++ )
				{
					var option = $( '<option />' );
					option.val(  local.pagination.values[i] );
					option.text( local.pagination.values[i] );

					option.appendTo( local.pagination[posValue].select );
				}

				// Set attributes
				local.pagination[posValue].first.attr( 'title', 'Go to previous page' );
				local.pagination[posValue].last.attr(  'title', 'Go to next page' );
				local.pagination[posValue].first.attr(  'href', '#first' );
				local.pagination[posValue].last.attr(   'href', '#last'  );
				local.pagination[posValue].select.attr(   'id', 'select_' + posValue + '_' + ( new Date( )).getTime( ));
				local.pagination[posValue].label.attr(   'for', local.pagination[posValue].select.attr( 'id' ));

				// Set text
				local.pagination[posValue].label.text( 'Show per page' );
				local.pagination[posValue].first.text( '\u2190' );
				local.pagination[posValue].last.text(  '\u2192' );

				// Set classes
				local.pagination[posValue].first.addClass( 'active' );
				local.pagination[posValue].last.addClass(  'active' );
				local.pagination[posValue].all.addClass(   'pagination ' + posValue );

				if( !local.view.records )
				{
					local.pagination[posValue].select.addClass( 'inactive' );
					local.pagination[posValue].label.addClass(  'inactive' );
				}

				// Sink events
				local.pagination[posValue].all.on( 'click', 'a', eventSink );

				// Bind events
				local.pagination[posValue].all.on(     'click', 'a', setPage    );
				local.pagination[posValue].select.on( 'change',      setPerPage );

				// Append elements
				if( local.settings.admin )
				{
					local.pagination[posValue].select.appendTo( local.pagination[posValue].perPage );
					local.pagination[posValue].label.appendTo(  local.pagination[posValue].perPage );
				}
				else
				{
					local.pagination[posValue].label.appendTo(  local.pagination[posValue].perPage );
					local.pagination[posValue].select.appendTo( local.pagination[posValue].perPage );
				}

				local.pagination[posValue].perPage.appendTo( local.pagination[posValue].all );
				local.pagination[posValue].first.appendTo(   local.pagination[posValue].all );
				local.pagination[posValue].last.appendTo(    local.pagination[posValue].all );

				local.pagination[posValue].all.wrapInner( '<div />' );
			});

			// Append elements
			local.table.appendTo(  local.wrapper );

			if( local.settings.responsive )
				local.responsive.appendTo( local.wrapper );

			local.table.wrap( '<div class = "scrollable">' );

			if( undefined != local.pagination.upper ) local.pagination.upper.all.prependTo( local.wrapper );
			if( undefined != local.pagination.lower ) local.pagination.lower.all.appendTo(  local.wrapper );

			local.wrapper.insertAfter( local.placeholder );

			local.placeholder.remove( );

			drawRecordSubset(    );
			drawPageLinks(       );
			highlightPerPage(    );
			highlightSort(       );
			drawResponsiveTable( );
		});
	};
})( jQuery );
